import { createFileRoute, Outlet } from '@tanstack/react-router';

// System admins own every settings page; org managers reach only the data
// source page. Each child carries its own guard, so this layout has none.
export const Route = createFileRoute('/$slug/organization-settings')({
  component: Outlet
});
